// TUT-498 — a ação em massa das listas (`POST /lotes`).
import { demoApi } from "../demo-data";
import { aplicarLoteNaDemo } from "../demo/lotes";
import type { PedidoDeLote, RespostaDoLote } from "../types";
import { apiDoFinanceiro } from "./financeiro";
import { demoAccountsReceivable, request } from "./infra";

// Lido aqui, e não importado: o empacotador só dobra a constante no módulo
// que a escreve, e é isso que tira o demo do build de produção (TUT-448).
const useDemoApi = import.meta.env.VITE_API_MODE === "demo";

export const apiDosLotes = {
  /**
   * Um lote: o resultado vem POR ITEM, na ordem do pedido (o repetido conta
   * uma vez). A recusa de um item não derruba os outros — a tela lista o que
   * "ficou de fora" com o motivo que a API escreveu.
   */
  aplicarLote(pedido: PedidoDeLote): Promise<RespostaDoLote> {
    if (useDemoApi) {
      return aplicarLoteNaDemo(pedido, {
        concluirPrazo: (id) => demoApi.updateDeadline(id, { status: "completed" }),
        reatribuirPrazo: (id, responsavelId) => demoApi.reassignDeadline(id, responsavelId),
        reatribuirPeca: (id, responsavelId) => demoApi.reassignLegalBrief(id, responsavelId),
        reatribuirLaudo: (id, responsavelId) => demoApi.reassignExpertReport(id, responsavelId),
        lerRecebivel: (id) => demoAccountsReceivable.find((conta) => conta.id === id),
        transicionarRecebivel: (id, para, motivo, vencimento) =>
          apiDoFinanceiro.transitionAccountsReceivable(id, para, motivo, vencimento),
        registrarRecebimento: (id, dia) => apiDoFinanceiro.registerAccountsReceivableReceipt(id, dia),
      });
    }
    return request<RespostaDoLote>("/lotes", {
      method: "POST",
      body: JSON.stringify(pedido),
    });
  },
};
